import { Injectable } from '@angular/core';
const TOKEN_KEY = 'auth-token';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';
const USER_KEY = 'auth-user';
const CREDENTIALS = 'credentials';
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() { }
  /**
   * signout
   */
  signOut(): void {
    localStorage.clear();
    this.deleteAllLocalStorage();
  }
  /**
   * save token
   * @param token
   */
  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
    const user = this.getUser();
    if (user.id) {
      this.saveUser({ ...user, accessToken: token });
    }
  }
  /**
   * get token
   * @returns
   */
  public getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }
  /**
   * save refresh token
   * @param token
   */
  public saveRefreshToken(token: string): void {
    localStorage.removeItem(REFRESHTOKEN_KEY);
    localStorage.setItem(REFRESHTOKEN_KEY, token);
  }
  /**
   * get refresh token
   * @returns
   */
  public getRefreshToken(): string | null {
    return localStorage.getItem(REFRESHTOKEN_KEY);
  }
  /**
   * save user
   * @param user
   */
  public saveUser(user: any): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, btoa(encodeURIComponent(JSON.stringify(user))));
  }
  /**
   * get user
   * @returns
   */
  public getUser(): any {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(decodeURIComponent(atob(user)));
    }
    return {};
  }
  /**
   * save item to local storage
   * @param key
   * @param value
   */
  public saveLocalStorage(key:any,value:any){
    localStorage.removeItem(key);
    if(this.isJsonString('"'+value+'"')){
      localStorage.setItem(key, btoa(JSON.stringify(value)));
    }else{
      localStorage.setItem(key, btoa(value));
    }
  }
  /**
   * get item from local storage
   * @param key
   */
  public getLocalStorage(key:any){
    let getVal:any=localStorage.getItem(key);
    let decryptVal=getVal != null ? atob(getVal) : '';
    if(this.isJsonString(decryptVal) && decryptVal != null){
      return JSON.parse(decryptVal);
    }else{
       return decryptVal;
    }
  }
  /**
   * delete item from local storage
   * @param key
   */
   public deleteLocalStorage(key:any){
    localStorage.removeItem(key);
  }
  /**
   * Delete all local storage
   */
  deleteAllLocalStorage(): void {
    localStorage.clear();
  }
  /**
   * check is json string
   * @param str
   * @returns
   */
  public isJsonString(str:any) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }
}



